import { logos } from './logos';
import { LogoDefinition, Props } from './types';

const Brand = ({ logo, size = 16, sx, ...props }: Props) => {
  const logoFound: LogoDefinition = logos.find((element) => element.id === logo) || logos[0];
  const { width, height, svgContent } = logoFound;

  return (
    <svg
      fill="none"
      style={{ height: `${size}px`, ...sx }}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {svgContent.map((svg, index) => {
        const { type: Tag, data, fill, ...attrs } = svg;
        return <Tag d={data} fill={fill} key={`${index}-${data}-${fill}`} {...attrs} />;
      })}
    </svg>
  );
};
Brand.displayName = 'Brand';

export default Brand;
